import angular from 'angular';

/**
 * @param {any} uibNestedDropdownService
 * @returns {any}
 */
const dropdownServiceDecorator = /* @ngInject */ (
	/** @type {any} */ uibNestedDropdownService,
) => uibNestedDropdownService;

/** @type {any[]} */
const openScopes = [];

/** @type {import('angular').IRootScopeService} */
let rootScope;

const getUpperScope = () => {
	if (openScopes.length === 0) {
		return null;
	}

	return openScopes[openScopes.length - 1];
};

/**
 * @param {any} event_
 */
const closeDropdown = event_ => {
	if (event_.target.id !== '_nci_') {
		let upperScope = getUpperScope();
		while (upperScope) {
			// This method may still be called during the same mouse event that
			// unbound this event handler. So check upperScope before proceeding.
			if (!upperScope) {
				break;
			}

			if (event_ && upperScope.getAutoClose() === 'disabled') {
				break;
			}

			const toggleElement = upperScope.getToggleElement();
			if (event_ && toggleElement && toggleElement[0].contains(event_.target)) {
				break;
			}

			const $element = upperScope.getElement();
			if (event_ && upperScope.getAutoClose() === 'outsideClick' && $element && $element[0].contains(event_.target)) {
				break;
			}

			upperScope.isOpen = false;
			openScopes.pop();

			if (!rootScope.$$phase) {
				upperScope.$apply();
			}

			// just close upper dropdown if ESC was pressed
			if (angular.isUndefined(event_)) {
				break;
			}

			upperScope = getUpperScope();
		}
	}
};

/**
 * @param {any} event_
 */
const escapeKeyBind = event_ => {
	if (event_.which === 27) {
		getUpperScope().focusToggleElement();
		closeDropdown(event_);
	}
};

class nestedDropdownService {
	/* @ngInject */
	/**
	 * @param {import('angular').IDocumentService} $document
	 * @param {any} $rootScope
	 */
	constructor(
		$document,
		$rootScope,
	) {
		this.$document = $document;
		rootScope = $rootScope;
	}

	/**
	 * @param {any} dropdownScope
	 */
	close(dropdownScope) {
		if (openScopes.includes(dropdownScope)) {
			const upperScope = getUpperScope();
			while (upperScope) {
				openScopes.pop().isOpen = false;
				if (upperScope === dropdownScope) {
					break;
				}
			}
		}

		if (!getUpperScope()) {
			this.$document.unbind('click', closeDropdown);
			this.$document.unbind('keydown', escapeKeyBind);
		}
	}

	isOnlyOpen() {}

	/**
	 * @param {any} dropdownScope
	 */
	open(dropdownScope) {
		let upperScope = getUpperScope();

		if (!upperScope) {
			this.$document.bind('click', closeDropdown);
			this.$document.bind('keydown', escapeKeyBind);
		}

		while (upperScope && upperScope !== dropdownScope) {
			// contained dropdown, do not close dropdown
			if (upperScope.getDropdownElement()[0].contains(dropdownScope.getElement()[0])) {
				break;
			}

			openScopes.pop().isOpen = false;
			upperScope = getUpperScope();
		}

		openScopes.push(dropdownScope);
	}
}

export default angular.module('nested-ui-bootstrap-dropdown', ['ui.bootstrap.dropdown'])
	.decorator('uibDropdownService', dropdownServiceDecorator)
	.service('uibNestedDropdownService', nestedDropdownService)
	.name;
